module.exports = __webpack_public_path__ + "img/order_cancelled.2329bf46.png";